import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";

const TimeInCard = () => {
  const navigate = useNavigate();
  const [exitData, setExitData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const employeeId = localStorage.getItem("employeeid");
  
  useEffect(() => {
    const fetchExitData = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          `https://ims-attendanceback.indevconsultancy.in/api/exit-slip/?employe_id=${employeeId}`
        );
        
        setExitData(res.data);
        setError(null);
      } catch (error) {
        console.error("Error fetching exit data:", error);
        setError("डेटा लोड करने में समस्या आई। कृपया बाद में पुनः प्रयास करें।");
      } finally {
        setLoading(false);
      }
    };

    if (employeeId) {
      fetchExitData();
    } else {
      setError("कर्मचारी आईडी उपलब्ध नहीं है");
      setLoading(false);
    }
  }, [employeeId]);

  const handleOkClick = () => {
    navigate("/kitchen");
  };

  const handleCancelClick = () => {
    // Clear exit-related data from localStorage if needed
    localStorage.removeItem("exitName");
    localStorage.removeItem("exitTime");
    localStorage.removeItem("exitImage");
    localStorage.removeItem("latitude_exit");
    localStorage.removeItem("longitudeexit");
    
    navigate("/kitchen");
  };

  if (loading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">लोड हो रहा है...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
        <div className="alert alert-danger text-center">
          <h4>त्रुटि</h4>
          <p>{error}</p>
          <button className="btn btn-primary" onClick={() => window.location.reload()}>
            पुनः प्रयास करें
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light py-4">
      <div className="container my-3">
        <div className="card shadow text-center">
          <h4 className="card-header fs-3 fw-semibold bg-primary text-white">
            उपस्थिति पुष्टिकरण
          </h4>

          <div className="card-body bg-light">
            <div className="mb-4">
              <h5>
                <strong>नाम:</strong> {exitData?.employee_name || "उपलब्ध नहीं"}
              </h5>
              <h6 className="text-muted">
                <strong>बाहर निकलने का समय:</strong> {exitData?.exit_time || "उपलब्ध नहीं"}
              </h6>
            </div>

            <div className="row justify-content-center mb-4">
              <div className="col-md-5 mb-3 mb-md-0">
                <h6 className="mb-2">बाहर निकलने की छवि</h6>
                {exitData?.exitimage ? (
                  <img
                    src={exitData.exitimage}
                    alt="बाहर निकलने की छवि"
                    className="rounded-circle shadow img-fluid"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                      border: "3px solid #c21858",
                    }}
                  />
                ) : (
                  <div className="text-danger fw-semibold p-3 border rounded">
                    कोई छवि उपलब्ध नहीं है
                  </div>
                )}
              </div>

              <div className="col-md-5">
                <h6 className="mb-2">प्रोफाइल छवि</h6>
                {exitData?.profileimg ? (
                  <img
                    src={exitData.profileimg}
                    alt="प्रोफाइल छवि"
                    className="rounded-circle shadow img-fluid"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                      border: "3px solid #007bff",
                    }}
                  />
                ) : (
                  <div className="text-danger fw-semibold p-3 border rounded">
                    कोई छवि उपलब्ध नहीं है
                  </div>
                )}
              </div>
            </div>

            <div className="mb-4">
              <strong>जीपीएस स्थान:</strong> 
              {exitData?.latitude && exitData?.longitude 
                ? `${exitData.latitude}°N, ${exitData.longitude}°E`
                : "उपलब्ध नहीं"
              }
            </div>

            <div className="d-flex justify-content-center gap-3">
              <button
                className="btn btn-success px-4 fw-semibold"
                onClick={handleOkClick}
              >
                ठीक है
              </button>

              <button
                className="btn btn-danger px-4 fw-semibold"
                onClick={handleCancelClick}
              >
                रद्द करें
              </button>
            </div>
          </div>

          <div className="card-footer text-muted small">
            तकनीकी साझेदार: Indev Consultancy ©2025
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimeInCard;